module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1CAPIzk/tc-custom/9781644051986.jpg?1685327059740",
      "alt": "This image is the cover for the book Stealing His Heart, Dreamspun Beyond"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Stealing His Heart, Dreamspun Beyond\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i')])]), _c('p', [_c('span', {
    staticStyle: {
      "color": "#333333",
      "font-style": "normal",
      "font-variant-ligatures": "normal",
      "font-variant-caps": "normal",
      "font-weight": "400",
      "letter-spacing": "normal",
      "orphans": "2",
      "text-align": "start",
      "text-indent": "0px",
      "text-transform": "none",
      "white-space": "normal",
      "widows": "2",
      "word-spacing": "0px",
      "-webkit-text-stroke-width": "0px",
      "text-decoration-style": "initial",
      "text-decoration-color": "initial",
      "display": "inline !important",
      "float": "none"
    }
  }, [_c('strong', [_vm._v("Max and Danny’s story will delight paranormal romance fans.")]), _vm._v(" -- "), _c('em', [_vm._v("Publishers Weekly")]), _vm._v(", "), _c('strong', [_vm._v("Starred Review")])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    staticStyle: {
      "color": "#333333",
      "font-style": "normal",
      "font-variant-ligatures": "normal",
      "font-variant-caps": "normal",
      "letter-spacing": "normal",
      "orphans": "2",
      "text-align": "start",
      "text-indent": "0px",
      "text-transform": "none",
      "white-space": "normal",
      "widows": "2",
      "word-spacing": "0px",
      "-webkit-text-stroke-width": "0px",
      "background-color": "#ffffff",
      "text-decoration-style": "initial",
      "text-decoration-color": "initial",
      "float": "none",
      "display": "inline !important"
    }
  }, [_vm._v("This touching erotic romance by Baker")])]), _c('span', {
    staticStyle: {
      "color": "#333333",
      "font-style": "normal",
      "font-variant-ligatures": "normal",
      "font-variant-caps": "normal",
      "font-weight": "400",
      "letter-spacing": "normal",
      "orphans": "2",
      "text-align": "start",
      "text-indent": "0px",
      "text-transform": "none",
      "white-space": "normal",
      "widows": "2",
      "word-spacing": "0px",
      "-webkit-text-stroke-width": "0px",
      "background-color": "#ffffff",
      "text-decoration-style": "initial",
      "text-decoration-color": "initial",
      "display": "inline !important",
      "float": "none"
    }
  }, [_c('strong', [_vm._v(" takes place in a paranormal universe where all types of beings live together in harmony and all types of love is accepted without question; highly recommended.")]), _vm._v(" -- "), _c('em', [_vm._v("Library Journal")])])]), _c('p', [_c('b', [_c('i', [_vm._v("Connoll Pack")])])]), _c('p', [_vm._v("Love sneaks in like a thief in the night.")]), _vm._v(" "), _c('p', [_vm._v("Danny’s parents raised him to believe his wolf was a curse. He’s part of the wealthy and powerful Connoll Pack, but only nominally. He abandoned that world to volunteer with supernatural kids, and he isn’t looking for a mate….")]), _vm._v(" "), _c('p', [_vm._v("Max is a shifter who is also a detective. He’s working a case that could make or break his career. Danny’s caught up in the case he’s on, and he’s also irresistible. They’re a bad match—Max, an Alpha having trouble with his new powers and Danny, who trusts Alphas as far as he could throw one. But they can’t get enough of each other, and they might bond before they even see it coming.")]), _vm._v(" "), _c('p', [_vm._v("They could be amazing together, but they have to get past a few obstacles—especially since someone close to Danny might be involved in the thefts Max is investigating.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bru Baker\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0